import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

// 📶 Nouveau design (tour 34), d'après Etats.html : bandeau en haut de l'écran tant qu'Internet est
// coupé (événements « offline » et « online » du navigateur), « Connexion Internet perdue. Ce
// message disparaîtra dès son retour. »
const isOffline = () => typeof navigator !== "undefined" && navigator.onLine === false;

function OfflineBannerNd() {
  const { t } = useTranslation();
  const [offline, setOffline] = useState(isOffline);
  useEffect(() => {
    const down = () => setOffline(true);
    const up = () => setOffline(false);
    window.addEventListener("offline", down);
    window.addEventListener("online", up);
    return () => {
      window.removeEventListener("offline", down);
      window.removeEventListener("online", up);
    };
  }, []);
  if (!offline) return null;
  return (
    <Banner role="status" data-testid="nd-offline">
      <strong>{t("nd.states.offlineTitle")}</strong> {t("nd.states.offlineText")}
    </Banner>
  );
}

const Banner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3000;
  padding: 12px 16px;
  background: var(--nd-surface);
  background-image: linear-gradient(var(--nd-orange-doux), var(--nd-orange-doux));
  border-bottom: 1px solid var(--nd-trait);
  color: var(--nd-texte);
  font-family: var(--nd-police-texte);
  font-size: 14px;
  line-height: 1.45;
  text-align: center;

  strong {
    font-weight: 600;
    color: var(--nd-orange-texte);
  }
`;

export default OfflineBannerNd;
